import {Component, h, Prop} from '@stencil/core';
import {Article} from "../../utils/types";
import {t} from "../../../../redux/utils";

@Component({
    tag: 'rtr-article-details-features',
    styleUrl: 'style.sass',
    shadow: false,
})
export class RtrArticleDetailsFeatures {
    @Prop() article: Article;

    get featuresText() {
        return t('details.features')
    }

    render() {
        return (
            <div class="ADFWrapper">
                <rentware-spacer size="S"/>
                <span class="ADFName">{this.featuresText}</span>
                <rentware-spacer size="S"/>
                <span class="ADFFeatures" innerHTML={this.article.features}/>
                <rentware-spacer size="S"/>
                <rentware-divider/>
            </div>
        )
    }
}
